export default {
      id: "icon-videos-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "icons.svg#icon-videos",
      toString: function () {
        return this.url;
      }
    }